import { Component, forwardRef, Input } from '@angular/core';
import { ControlContainer, NG_VALUE_ACCESSOR } from '@angular/forms';
import { BaseUiFormControl } from '../base-ui-form-control';

@Component({
  selector: 'ui-time',
  templateUrl: './ui-time.component.html',
  styleUrls: ['./ui-time.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => UiTimeComponent),
    multi: true
  }]
})
export class UiTimeComponent extends BaseUiFormControl {
  @Input() showSeconds: boolean = false;
  @Input() showMeridian: boolean = true;
  @Input() meridians = ['AM', 'PM'];
  @Input() minuteStep: number = 5;
  @Input() allowMouseWheel: boolean = true;
  @Input() showSpinners: boolean = false;

  constructor(controlContainer: ControlContainer) {
    super(controlContainer);
  }

  get value() {
    return this.control.value;
  }

  set value(value) {
    this.onChange(value);
    this.onTouched();
  }

  onTouched: any = () => { };
  onChange: any = () => { };

  writeValue(value) {
    if (value) {
      this.value = value;
    }
  }

  registerOnTouched(fn) {
    this.onTouched = fn;
  }

  registerOnChange(fn) {
    this.onChange = fn;
  }

  getFormGroup() {
    return this.controlContainer.control;
  }
}